






import { BarChartValues } from "@/types/bar-chart";
import BarChartRow from "@/components/BarChartRow.vue";
import { Component, Vue, Prop } from "vue-property-decorator";

@Component({ components: { BarChartRow } })
export default class BarChart extends Vue {
  @Prop({ required: true })
  rows!: BarChartValues[];
}
